import main from './main';
import user from './user';

export default {
    namespaced: true,
    modules: {
        main,
        user
    }
};
